import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { EuiIconModule } from '../atoms';
import { EuiChipModule } from '../eui-chip/eui-chip.module';
import { EuiButtonModule } from '../eui-button';
import { EuiTooltipDirectiveModule } from '../../directives/index';

import { EuiMenuComponent } from './eui-menu.component';
import { EuiMenuTooltipContent } from './pipes/eui-menu-tooltip-content.pipe';
import { EuiMenuItemComponent } from './eui-menu-item.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        EuiIconModule,
        EuiChipModule,
        EuiButtonModule,
        EuiTooltipDirectiveModule,
    ],
    declarations: [
        EuiMenuComponent,
        EuiMenuItemComponent,
        EuiMenuTooltipContent,
    ],
    exports: [
        EuiMenuComponent,
    ],
})
export class EuiMenuModule { }
